import { render, staticRenderFns } from "./SwipeSearchImage.vue?vue&type=template&id=9043f5c4&scoped=true&"
import script from "./SwipeSearchImage.vue?vue&type=script&lang=js&"
export * from "./SwipeSearchImage.vue?vue&type=script&lang=js&"
import style0 from "./SwipeSearchImage.vue?vue&type=style&index=0&id=9043f5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9043f5c4",
  null
  
)

export default component.exports